export const environment = {
    production: true,
    apiUrl: 'https://api-dev.olonera.com/api',
    woocommerceUrl: 'https://olonera-dev-woo.mystagingwebsite.com',
    requiredRole: 'Practitioner'
};
